import React from 'react';
import {Icons} from '../../../assets';
import {Button, ButtonSize, ButtonVariant} from '../../../components/button';
import {ContactItem, ProfileHeaderCard} from '../../../components/profile-header-card';
import {Account} from '../../../models';

export type {ContactItem};

type ProfileHeaderSectionProps = {
  account: Account;
  checkingSaved: boolean;
  contactItems: ContactItem[];
  displayName: string;
  extraActions?: React.ReactNode;
  isSaved: boolean;
  isSaving: boolean;
  showSaveAction: boolean;
  onSaveToggle: () => void;
};

export const ProfileHeaderSection: React.FC<ProfileHeaderSectionProps> = ({
  account,
  checkingSaved,
  contactItems,
  displayName,
  extraActions,
  isSaved,
  isSaving,
  onSaveToggle,
  showSaveAction,
}) => {
  const savedButton = showSaveAction ? (
    <Button
      disabled={isSaving || checkingSaved}
      loading={isSaving}
      onClick={onSaveToggle}
      size={ButtonSize.SM}
      startIcon={
        isSaved ? (
          <img alt="Saved" className="h-4 w-4" src={Icons.BOOKMARK_FILLED} />
        ) : (
          <img alt="Save" className="h-4 w-4" src={Icons.BOOKMARK} />
        )
      }
      variant={isSaved ? ButtonVariant.Secondary : ButtonVariant.Outline}>
      {isSaved ? 'Saved' : 'Save Later'}
    </Button>
  ) : null;

  const rightActions =
    extraActions || savedButton ? (
      <>
        {extraActions}
        {savedButton}
      </>
    ) : null;

  return (
    <section className="mb-6 rounded-2xl px-6 py-6">
      <ProfileHeaderCard
        contactItems={contactItems}
        imageUrl={account.profilePictureResource?.url}
        name={displayName}
        nameHeadingClassName="text-3xl font-semibold text-gray-900"
        rightActions={rightActions}
        subtitle={account.title || account.bio || undefined}
      />
    </section>
  );
};
